export default "__VITE_ASSET__MORwUP00__"